export const REFERRAL_SOURCE_ID = {
    Other: 9,
};
